export default __webpack_public_path__ + "static/media/opne-link.aa791fe8.svg";